import { ChevronDownIcon as ChevronDown, Typography } from "@packages/ds";
import styled from "styled-components";

import Checkbox from "ds/Checkbox";
import * as Dialog from "ds/Dialog";
import Input from "ds/Input";
import Select from "ds/Select";
import * as Sticker from "ds/Sticker";

export const ConfigureAutoscalingWrapper = styled.div`
  min-height: 100vh;
  position: absolute;
  background-color: var(--mode-bg-neutral-weakest);
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99;
`;

export const AppsAndResources = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;
export const ThresholdsValues = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const UpperThreshold = styled.div`
  display: flex;
  align-items: center;
  margin: 16px 0 0 40px;
  position: relative;
`;
export const ValuesWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
export const LowerThreshold = styled.div`
  display: flex;
  align-items: center;
  margin-left: 40px;
  position: relative;
`;

export const ThresholdInput = styled(Input)`
  max-width: 60px;
  margin-left: 8px;

  label {
    margin-top: -24px;
  }

  input {
    max-width: 100%;
  }
  }
`;
export const DurationInput = styled(Input)`
  max-width: 80px;

  label {
    margin-top: -24px;
  }

  input {
    max-width: 100%;
  }
`;
export const DurationOptions = styled(Select)`
  width: 120px;
  & [aria-disabled="true"] {
    div > div {
      color: var(--mode-text-neutral-weakest-disabled);
    }
  }
`;
export const CoolDownDurationOptions = styled(Select)`
  width: 120px;
  & [aria-disabled="true"] {
    div > div {
      color: var(--mode-text-neutral-weakest-disabled);
    }
  }
`;
export const ActionButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 31px;
`;
export const ApplicationLabel = styled(Typography.BodyText)`
  color: var(--mode-text-neutral-weakest);
  margin-right: 16px;
`;
export const ShowMetrics = styled(ChevronDown)<{ $isOpen: boolean }>`
  cursor: pointer;
  width: 32px;
  height: 32px;
  padding: 4px;

  ${({ $isOpen }) => $isOpen && `transform: rotate(180deg);`}

  &:hover {
    background-color: var(--mode-bg-neutral-weaker);
    border-radius: 50%;
  }
`;

export const EnableThresholds = styled.div`
  display: flex;
  position: relative;
  gap: 4px;
`;

export const SelectedAppContainer = styled.div`
  display: flex;
`;
export const EnableCheckbox = styled(Checkbox)`
  margin: 0;
`;
export const EnableThresholdsDialog = styled(Dialog.Root)`
  position: relative;
`;
export const MinInstancesDialog = styled(Dialog.Root)``;
export const MaxInstancesDialog = styled(Dialog.Root)``;
export const Content = styled(Dialog.Content)`
  height: 160px;
  position: absolute;
  left: 30px;
  &[data-side="bottom"] {
    top: 340px;
  }
`;

export const MaxContent = styled(Dialog.Content)`
  height: 160px;
  position: absolute;
  &[data-side="bottom"] {
    top: 320px;
    right: -98vw;
  }
`;
export const MinContent = styled(Dialog.Content)`
  height: 160px;
  position: absolute;
  &[data-side="bottom"] {
    top: 320px;
    right: -80vw;
  }
`;

export const MaximumInstancesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
`;
export const MinimumInstancesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
`;

export const InstancesWrapper = styled.div`
  display: flex;
  gap: 24px;
`;
export const MaximumInstances = styled(Input)`
  max-width: 60px;
  display: flex;

  label span {
    display: block;
    min-width: 130px;
  }

  input {
    max-width: 100%;
  }
`;
export const MinimumInstances = styled(Input)`
  max-width: 60px;
  display: flex;

  label span {
    display: block;
    min-width: 130px;
  }

  input {
    max-width: 100%;
  }
`;

export const ContentWrapper = styled.div`
  margin: 0 128px;
`;

export const DescriptionWrapper = styled.div`
  text-align: center;

  & label {
    display: block;
    margin-bottom: 24px;
  }

  & p {
    margin: 32px 0 40px 0;
  }
`;

export const BoldText = styled(Typography.BodyText)`
  display: inline;
`;

export const VendorIconWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  margin-top: 45px;
  height: 32px;

  a {
    background-color: unset;
    &:hover {
      background-color: unset;
    }
  }
`;

export const StickerError = styled(Sticker.Root)`
  max-width: fit-content;
  justify-content: flex-start;
  margin: 24px auto;
`;

export const StickerPermissions = styled(Sticker.Root)`
  margin: 40px 128px;
}`;

export const ErrorsContent = styled(Sticker.Text)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const GenericError = styled(Sticker.Text)`
  gap: 12px;
`;
export const ErrorsList = styled(Sticker.Text)`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
  padding-left: 30px;
  & p {
    color: var(--theme-neutral-900);
    margin: 0;
    &::before {
      content: "• ";
      margin-right: 4px;
    }
  }
`;
export const ErrorDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--theme-critical-600);
  position: absolute;
  left: -24px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
`;

export const InstancesLabel = styled(Typography.Label)<{ isValid: boolean }>`
  ${({ isValid }) => !isValid && `color: var(--theme-critical-600)`}
`;
